"use strict";
/********************************************************************************
  HxObjectID.ts

  Copyright (c) Microsoft Corporation. All rights reserved.
********************************************************************************/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxObjectID = void 0;
var HxObjectType_1 = __importDefault(require("./HxObjectType"));
var HxObjectID = /** @class */ (function () {
    function HxObjectID(objectId) {
        if (objectId.length != 92) {
            throw new Error("Invalid HxObjectID");
        }
        this.objectId = objectId;
    }
    HxObjectID.prototype.getHandle = function () {
        return parseInt(this.objectId.split('.')[3], 16);
    };
    HxObjectID.prototype.toString = function () {
        return this.objectId;
    };
    HxObjectID.prototype.getCompactIDString = function () {
        return this.objectId.substring(0, this.objectId.lastIndexOf("."));
    };
    HxObjectID.prototype.getObjectType = function () {
        var objectTypeString = HxObjectType_1.default[parseInt(this.objectId.split('.')[1], 16)];
        var keyOfObjectTypeString = objectTypeString;
        var type = HxObjectType_1.default[keyOfObjectTypeString];
        return type;
    };
    HxObjectID.prototype.isEqual = function (hxObjectId) {
        // Allow isEqual to be called with null | undefined and just return false to avoid calling code to have to have a bunch of extra guards around this case
        if (!hxObjectId) {
            return false;
        }
        // Compare the first 4 substrings that lead up to the CompactID part of the ObjectID, rest of ObjectID can change when objects move across persistence groups but they are technically the same objects.
        var lhs = hxObjectId.toString().substring(0, hxObjectId.toString().lastIndexOf("."));
        return this.objectId.startsWith(lhs);
    };
    HxObjectID.prototype.isNil = function () {
        return this.isEqual(HxObjectID.objectIdNil);
    };
    HxObjectID.getCompactIDFromTypeAndHandle = function (handle, type) {
        var typeString = type.toString(16).toUpperCase().padStart(16, '0');
        var handleString = handle.toString(16).toUpperCase().padStart(16, '0');
        return this.nilVersion.concat('.', typeString, '.', this.nilUnusedGuidBytes, '.', handleString);
    };
    HxObjectID.getFakeHxObjectId = function (name) {
        if (name.length <= 92) {
            return new HxObjectID(name.padEnd(92, ' '));
        }
        else {
            return new HxObjectID(name.slice(0, 92));
        }
    };
    HxObjectID.objectIdNil = new HxObjectID("AAA=.0000000000000000.AAAAAAAAAAA=.0000000000000000.AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==");
    HxObjectID.nilVersion = "AAA=";
    HxObjectID.nilUnusedGuidBytes = "AAAAAAAAAAA=";
    return HxObjectID;
}());
exports.HxObjectID = HxObjectID;
exports.default = HxObjectID;
